import React from 'react';
import { Modal } from 'react-bootstrap';
import swal from 'sweetalert';

import { Plus, Trash2 } from 'lucide-react';
import i18n from '../../../../../i18n';
import { clientFundSettle } from '../services/auctionApprovalServices';
import FileInputNew from '../../../../helpers/fileInputNew';

export class AuctionSettleModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_loading: false,
      input: {},
      errors: {},
      fileInputs: [],
      fileReceipt: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      input: { ...prevState.input, [name]: value },
    }));
  };

  onFileChange = (event) => {
    if (event.target.name === 'fileReceipt') {
      this.setState({ fileReceipt: event.target.files[0] });
    }
  };

  onFileChangeNew = (e, index) => {
    const updatedInputs = [...this.state.fileInputs];
    updatedInputs[index].file = e.target.files[0];
    this.setState({ fileInputs: updatedInputs });
  };

  addNewFileInput = () => {
    this.setState((prevState) => ({
      fileInputs: [...prevState.fileInputs, { id: prevState.fileInputs.length + 1, file: null }],
    }));
  };

  removeFile = (index) => {
    this.setState((prevState) => ({
      fileInputs: prevState.fileInputs.filter((_, i) => i !== index),
    }));
  };

  validateOfflineForm = () => {
    const { group } = this.props;
    const { fileReceipt } = this.state;

    // Required values come from props.group, not from state.input
    if (!group?.client_name || !group?.bank_name || !group?.bank_account) {
      return false;
    }

    // Must have receipt file uploaded
    return fileReceipt !== null;
  };

  async handleSubmit(event) {
    const { input } = this.state;
    const { selectedIds, group } = this.props;
    event.preventDefault();

    const isValidOffline = this.validateOfflineForm();

    if (!isValidOffline) {
      swal(i18n.t('failed'), i18n.t('all_mandatory'), 'error');
      return;
    }

    try {
      this.setState({ is_loading: true });
      let { fileInputs } = this.state;
      const formData = new FormData();

      // Common fields
      selectedIds.forEach((id, index) => {
        formData.append(`selected_ids[${index}]`, id);
      });
      formData.append('group', group.id);
      formData.append('client_name', this.props.group?.client_name || '');
      formData.append('bank', this.props.group?.bank_name || '');
      formData.append('account_number', this.props.group?.bank_account || '');
      formData.append('remarks', input.remarks || '');
      formData.append('total_payable', this.props.paymentApproval?.totalPayable || 0);

      if (this.state.fileReceipt) {
        formData.append('attachment', this.state.fileReceipt, this.state.fileReceipt.name);
      }

      if (fileInputs.length > 0) {
        fileInputs.forEach((input, index) => {
          if (input.file) {
            formData.append(`additional_attachments[${index}]`, input.file, input.file.name);
          }
        });
      }

      const response = await clientFundSettle(formData);
      if (response && response.success) {
        swal(i18n.t('success'), i18n.t('auction_approved'), 'success');
        this.setState({ is_loading: false });
        if (this.props.onSuccess) {
          this.props.onSuccess(); // trigger parent refresh
        } else {
          this.props.onClose();
        }
      } else {
        swal(i18n.t('failed'), response.message, 'error');
        this.setState({ is_loading: false });
      }
    } catch (err) {
      console.log(err);
      this.setState({ is_loading: false });
    }
  }

  renderFileUpload = () => {
    const { fileInputs } = this.state;

    return (
      <div className="wallet-file-section">
        <div className="mb-3">
          <label className="wallet-form-label">{i18n.t('attachment')}</label>
          <div className="wallet-file-input-wrapper">
            <FileInputNew
              wrapperClass="wallet-file-input"
              placeholder={i18n.t('choose_file')}
              id="fileReceipt"
              name="fileReceipt"
              onChange={this.onFileChange}
              className="form-control"
              accept=".jpg,.jpeg,.png,.pdf"
            />
          </div>
        </div>

        {/* Additional files - only for offline tab */}

        <div className="wallet-additional-files">
          <label className="wallet-form-label">{i18n.t('additional_doc')}</label>
          {fileInputs.map((input, index) => (
            <div key={input.id} className="wallet-file-row mb-2">
              <div className="wallet-file-input-container">
                <FileInputNew
                  wrapperClass="wallet-file-input"
                  className="form-control"
                  placeholder={i18n.t('choose_file')}
                  name="fileReceipt_addl"
                  id={`fileReceipt_addl_${index}`}
                  onChange={(e) => this.onFileChangeNew(e, index)}
                />
                <button
                  type="button"
                  className="wallet-remove-file-btn"
                  onClick={() => this.removeFile(index)}
                  title="Remove file"
                >
                  <Trash2 size={20} />
                </button>
              </div>
            </div>
          ))}
          <button className="wallet-add-file-btn" onClick={this.addNewFileInput} type="button">
            {/* <i className="fa fa-plus" /> */}
            <Plus size={20} />
            <span>{i18n.t('add_new')}</span>
          </button>
        </div>
      </div>
    );
  };
  renderOfflineForm = () => {
    const { errors } = this.state;
    const { paymentApproval, group = {} } = this.props;

    return (
      <div className="wallet-form-content">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('client_name')}</label>
            <input
              type="text"
              name="client_name"
              value={group.client_name || ''}
              // onChange={this.handleChange}
              className="wallet-form-input"
              disabled
              placeholder="Please enter client name"
            />
            <div className="wallet-error">{errors.client_name}</div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('bank_name')}</label>
            <input
              type="text"
              name="bank"
              value={group.bank_name || ''}
              // onChange={this.handleChange}
              className="wallet-form-input"
              disabled
              placeholder={i18n.t('bank_name')}
            />
            <div className="wallet-error">{errors.bank}</div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('account_number')}</label>
            <input
              type="text"
              name="account_number"
              value={group.bank_account || ''}
              // onChange={this.handleChange}
              className="wallet-form-input"
              disabled
              placeholder={i18n.t('enter_account_number')}
            />
            <div className="wallet-error">{errors.account_number}</div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('total_bid_amount')}</label>
            <input
              type="text"
              name="total_payable"
              value={paymentApproval.bidAmount || 0}
              // onChange={this.handleChange}
              className="wallet-form-input"
              disabled
              placeholder={i18n.t('total_bid_amount')}
            />
            <div className="wallet-error">{errors.total_payable}</div>
          </div>

          {paymentApproval.isVatIncluded && (
            <div className="col-md-6 mb-3">
              <label className="wallet-form-label">{i18n.t('vat')}</label>
              <input
                type="text"
                name="vat"
                value={paymentApproval.vat || ''}
                // onChange={this.handleChange}
                className="wallet-form-input"
                disabled
                placeholder={i18n.t('vat')}
              />
              <div className="wallet-error">{errors.vat}</div>
            </div>
          )}

          {paymentApproval.isServiceChargeIncluded && (
            <div className="col-md-6 mb-3">
              <label className="wallet-form-label">{i18n.t('service_charge')}</label>
              <input
                type="text"
                name="service_charge"
                value={paymentApproval.serviceCharge || ''}
                // onChange={this.handleChange}
                className="wallet-form-input"
                disabled
                placeholder={i18n.t('service_charge')}
              />
              <div className="wallet-error">{errors.service_charge}</div>
            </div>
          )}

          {paymentApproval.isServiceChargeVatIncluded && (
            <div className="col-md-6 mb-3">
              <label className="wallet-form-label">{i18n.t('service_charge_vat')}</label>
              <input
                type="text"
                name="service_charge_vat"
                value={paymentApproval.vatServiceCharge || ''}
                // onChange={this.handleChange}
                className="wallet-form-input"
                disabled
                placeholder={i18n.t('service_charge_vat')}
              />
              <div className="wallet-error">{errors.service_charge_vat}</div>
            </div>
          )}
          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('total_client_amount')}</label>
            <input
              type="text"
              name="total_client_amount"
              value={paymentApproval.totalPayable || ''}
              // onChange={this.handleChange}
              className="wallet-form-input"
              disabled
              placeholder={i18n.t('total_client_amount')}
            />
            <div className="wallet-error">{errors.total_client_amount}</div>
          </div>
        </div>
      </div>
    );
  };
  render() {
    const { show, onClose } = this.props;
    const { is_loading, input } = this.state;
    return (
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        dialogClassName="wallet-modal-dialog"
        className="wallet-fund-modal"
      >
        <Modal.Header closeButton className="wallet-modal-header">
          <Modal.Title className="wallet-modal-title">
            <i className="fa fa-wallet mr-2"></i>
            {i18n.t('payment_approval')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="wallet-modal-body">
          {/* Form Content */}
          <div className="wallet-form-container">
            <form className="wallet-form" autoComplete="off">
              {this.renderOfflineForm()}

              {/* File Upload Section */}
              {this.renderFileUpload()}

              {/* Remarks Section */}
              <div className="wallet-remarks-section">
                <label className="wallet-form-label">{i18n.t('remarks')}</label>
                <textarea
                  name="remarks"
                  value={input.remarks || ''}
                  onChange={this.handleChange}
                  rows={4}
                  className="wallet-textarea"
                  placeholder={i18n.t('enter_remarks')}
                />
              </div>

              {/* Action Buttons */}
              <div className="wallet-actions">
                <button type="button" className="wallet-btn wallet-btn-cancel" onClick={onClose}>
                  {i18n.t('cancel')}
                </button>
                <button
                  type="button"
                  className="wallet-btn wallet-btn-submit"
                  onClick={this.handleSubmit}
                  disabled={is_loading}
                >
                  {is_loading && <i className="fa fa-spinner fa-spin mr-2"></i>}
                  {i18n.t('approve')}
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
